import WidgetBalance from './components/widget-balance.svelte';

const config = window.juno_balance_widget_script_data;

const widget = new WidgetBalance({
  target: document.querySelector(`#${config.id} .inside`),
  props: {
    data: config,
  }
});
